import { useEffect } from 'react';

import { useParams, useSearchParams } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { validateAndSanitizeRedirectUrl } from '#client/utils';

/**
 * Logout Page
 * Logs the user out and optionally redirects to a specified URL.
 * Supports redirectTo in both query params and path params (base64 encoded).
 * Uses centralized redirect validation to prevent open redirects.
 * @returns {import('react').ReactElement} The Logout component
 */
const Logout = () => {
  const { logout } = useAuthentication();
  const [searchParams] = useSearchParams();
  const params = useParams();

  // Decode the path parameter (if present)
  const pathParam = params['*'];

  // Decode URL query param (if present)
  const urlRedirectTo = searchParams.get('redirectTo');

  // Validate and sanitize redirects using centralized utility
  // Priority: Path param > URL param > undefined (library default)
  const validatedPathRedirect = pathParam ? validateAndSanitizeRedirectUrl(pathParam, null) : null;
  const validatedUrlRedirect = urlRedirectTo
    ? validateAndSanitizeRedirectUrl(urlRedirectTo, null)
    : null;
  const redirectTo = validatedPathRedirect || validatedUrlRedirect;

  useEffect(() => {
    logout(redirectTo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PageLoading />;
};

export default Logout;
